import { ReactElement, useState } from "react"
import { Wrapper } from "../wrapper/wrapper"
import { FaqProps } from "./faq-props"
import * as S from './faq-style'

export function Faq ({ id, values }: FaqProps): ReactElement {
  const [selectedIndex, setSelectedIndex] = useState<number>()
  return <S.Container id={id}>
    <Wrapper>
      <S.Title>Perguntas frequentes</S.Title>
      {values.map((item, index) => <>
        <S.FaqTitle onClick={() => setSelectedIndex(index)} className={selectedIndex === index ? 'expanded' : ''}>{item.title}</S.FaqTitle>
        <S.FaqDescription className={selectedIndex === index ? 'open' : ''} dangerouslySetInnerHTML={{ __html: item.description }} />
      </>)}
    </Wrapper>
  </S.Container>
}